import React, { useState, useEffect, useRef } from "react";
import {
    Container,
    Grid,
    Button,
    TextField,
    InputAdornment,
    IconButton,
    Select,
    MenuItem,
    Box,
    InputLabel,
    OutlinedInput,
    FormControl,
    FormControlLabel,
    Radio,
    Typography
   
} from "@mui/material";
import { useTranslation } from "react-i18next";
import Pagination from "../../common/Pagination";
import ManageInventoryList from "../services/manageInventoryList";
import Skeleton from "../../common/Skeleton";
import SearchIcon from "@mui/icons-material/Search";
import { UpdateInventory } from "../services/updateInventory";
import * as XLSX from "xlsx";
import {
    LIST_LIMIT,
    INVENTORY_MODULE_CONSTANTS,
    SHEET_NAME,
    INVENTORY_LIST,
} from "../../../constants/constants";
import { useAppSelector } from "../../../redux/hooks";
import { Link } from "react-router-dom";
import Utility from "../../../utils/Utility";
import downloadDataToExcel from "../../../utils/ExcelDownloadUtility";
import MUIDataTable from "mui-datatables";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import DownloadButton from "../../common/DownloadBtn";
import CommonButton from "../../common/Button";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import lazyTypingUtils from "../../../utils/lazyTypingUtils";
import i18n from "../../../i18n";
import {SearchIconButton} from "../../../utils/searchUtils";

const ManageInventory = (props: any) => {
    const { handleLoader, showSnackbar } = props;
    const node = useRef<HTMLDivElement>(null);
    const { t } = useTranslation();
    
    const storecode = useAppSelector((state) => state?.common?.loggedInStoreCode) ?? null;
    const isDemoUser = useAppSelector((state) => state.common.demoUser) ?? false;

    
    useEffect(() => {
        totalPages != 0 ? productData(firstPage, limit) : null;
    }, []);
    
    const firstPage = 1;
    const [skeleton, setSkeleton] = useState(false);
    const [inventory, setInventory] = useState<any>();
    const [currentPage, setCurrentPage] = useState(firstPage);
    const [totalCount, setTotalCount] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [appliedFilter1, setAppliedFilter1] = useState<any>("none");
    const [appliedFilter2, setAppliedFilter2] = useState<any>("none");
    const [search, setSearch] = useState<string>("");
    const [quantity, setQuantity] = useState<string>("");
    const [limit, setLimit] = useState(LIST_LIMIT.MANAGE_INVENTORY_LIST_LIMIT);
    const [value, setValue] = useState<any>([]);
    const [hideColumnArr,setHideColumnArr] =useState<any>([]);
    const [fullWidthL, setFullWidthL] = useState<number>(0);
    const [loading, setLoading] = useState(false);
    const [colFilter,setColFilter] =useState<string>("");
    const [direction,setDirection]=useState<string>("");
    const [colName,setColName]=useState<string>("");
    const [isSearch,setIsSearch]=useState<boolean>(false);
    const [isQuantitySearch,setIsQuantitySearch]=useState<boolean>(false);
    const [showDownloadOptions , setShowDownloadOptions]=useState<boolean>(false);
    const [selectedColumn, setSelectedColumn] = useState<any>([]);

    const apiData: any[][] = [];

    const handleSorting =(changedColumn: any)=>{
        if(colName!=changedColumn){
            setDirection("asc");

        }else{
            setDirection(direction=="asc"? "desc":"asc");
        }
        
        setColName(changedColumn);   
        const columnName=changedColumn == "Product Code" || changedColumn=="商品コード" ? "shukkamoto_mng_hinban":
            changedColumn == "Cainz Product Code" || changedColumn == "カインズ商品コード" ? "daihyo_jan_cd":
                changedColumn == "Product Name" || changedColumn=="商品名" ? "prd_nm_kj":
                    changedColumn == "Product Price including Tax" || changedColumn=="税込商品価格" ? "bai_tanka_idx_zeikomi_1":
                        changedColumn == "Individual Shipping Fee" || changedColumn=="個別送料" ? "kobetsu_soryo_kn_ec":
                            "";   
        setColFilter(columnName);

    };

    const columns = [
        {
            name: t("bulk_product_index.sno"),
            options: {
                filter: true,
                sort: false,
                viewColumns: false,
                setHeaderCellProps: () => ({
                    style :  {
                        whiteSpace : "normal",
                        wordBreak : "break-word",
                        minWidth : 15
                    }
                }),
                setCellProps: () => ({
                    style: {
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        minWidth: 15,
                    },
                }),
            },
        },
        {
            name: t("bulk_product_index.product_code"),
            options: {
                filter: false,
                sort: false,
                setCellProps: () => ({
                    style: {
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        width: i18n.language === "jp" ? "110px" : "100px",
                    },
                }),
                display: hideColumnArr.includes("商品コード") ? false : true,
                customHeadLabelRender: (data: any) => {
                    return (
                        <Box>
                            {data.label}
                            <IconButton color="primary" size="small" onClick={(e)=>handleSorting(data.name)} >
                                {colFilter!="shukkamoto_mng_hinban" ? <SwapVertIcon className="swapVertIcon" /> : direction == "asc" ?<ArrowUpwardIcon className="sortingIconPosition"/>:<ArrowDownwardIcon className="sortingIconPosition"/> }
                            </IconButton>  
                        </Box>
                    );
                },
            },
        },
        {
            name: t("bulk_product_index.cainz_product_code"),
            options: {
                filter: true,
                sort: false,
                setCellProps: () => ({
                    style: {
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        maxWidth : "max-content"
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        width : "160px"
                    },
                }),
                viewColumns: false,
                customHeadLabelRender: (data:any) => {
                    return (
                        <Box>
                            {data.label}
                            <IconButton color="primary" size="small" onClick={(e)=>handleSorting(data.name)} >
                                {colFilter!="daihyo_jan_cd" ? <SwapVertIcon className="swapVertIcon"/> : direction == "asc" ?<ArrowUpwardIcon className="sortingIconPosition"/>:<ArrowDownwardIcon className="sortingIconPosition"/> }
                            </IconButton>  
                        </Box>
                    );
                },   
            },
        },
        {
            name: t("bulk_product_index.product_name"),
            options: {
                filter: true,
                sort: false,
                setCellProps: () => ({
                    style: {
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        minWidth: i18n.language === "jp" ? "70px" : "auto",
                        maxWidth : i18n.language === "jp" ? "250px" : "250px"
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        minWidth: i18n.language === "jp" ? "70px" : "auto",
                        maxWidth : i18n.language === "jp" ? "90px" : "110px"
                    },
                }),
                display: hideColumnArr.includes("商品名") ? false : true,
                customHeadLabelRender: (data:any) => {
                    return (
                        <Box>
                            {data.label}
                            <IconButton color="primary" size="small" onClick={(e)=>handleSorting(data.name)} >
                                {colFilter!="prd_nm_kj" ? <SwapVertIcon className="swapVertIcon" /> : direction == "asc" ?<ArrowUpwardIcon className="sortingIconPosition"/>:<ArrowDownwardIcon className="sortingIconPosition"/> }
                            </IconButton>  
                        </Box>
                    );
                },   
            },
        },
        {
            name: t("bulk_product_index.product_price_tax"),
            options: {
                filter: true,
                sort: false,
                setCellProps: () => ({
                    style: {
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        maxWidth : "max-content"
                    },
                }),
                display: hideColumnArr.includes("税込商品価格") ? false : true,
                setCellHeaderProps: () => ({className: "text_right",
                    style : {
                        maxWidth : "max-content"
                    }
                }),
                customHeadLabelRender: (data:any) => {
                    return (
                        <Box>
                            {data.label}
                            <IconButton color="primary" size="small" onClick={(e)=>handleSorting(data.name)} >
                                {colFilter!="bai_tanka_idx_zeikomi_1" ? <SwapVertIcon className="swapVertIcon"/> : direction == "asc" ?<ArrowUpwardIcon className="sortingIconPosition"/>:<ArrowDownwardIcon className="sortingIconPosition"/> }
                            </IconButton>  
                        </Box>
                    );
                },   
            },
        },
        {
            name: t("bulk_product_index.shipping_fee"),
            options: {
                filter: true,
                sort: false,
                setCellProps: () => ({
                    style: {
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        maxWidth: "max-content",
                    },
                }),
                display: hideColumnArr.includes("個別送料") ? false : true,
                setCellHeaderProps: () => ({className: "text_right",
                    style : {
                        maxWidth : "max-content"
                    }
                }),
                customHeadLabelRender: (data:any) => {
                    return (
                        <Box>
                            {data.label}
                            <IconButton color="primary" size="small" onClick={(e)=>handleSorting(data.name)} >
                                {colFilter!="kobetsu_soryo_kn_ec" ? <SwapVertIcon className="swapVertIcon" /> : direction == "asc" ?<ArrowUpwardIcon className="sortingIconPosition"/>:<ArrowDownwardIcon className="sortingIconPosition"/> }
                            </IconButton>  
                        </Box>
                    );
                },   
            },
        },
        {
            name: t("bulk_product_index.quantity"),
            options: {
                filter: true,
                sort: false,
                viewColumns: false,
                setCellProps: () => ({
                    style: {
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        minWidth: i18n.language === "jp" ? "20px" : "",
                        maxWidth : i18n.language === "jp" ? "60px" : "70px"
                    },
                }),
                setCellHeaderProps: () => ({className: "text_right",
                    style : {
                        minWidth: i18n.language === "jp" ? "20px" : "",
                        maxWidth : i18n.language === "jp" ? "40px" : "70px"
                    }
                }), 
                display: hideColumnArr.includes("在庫数") ? false : true,
            },
        },
        {
            name: t("bulk_product_index.ordered_quantity"),
            options: {
                filter: true,
                sort: false,
                setCellProps: () => ({
                    style: {
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        // maxWidth: 150,
                        textAlign:"right",
                        minWidth: i18n.language === "jp" ? "20px" : "",
                        maxWidth : i18n.language === "jp" ? "20px" : "70px"
                        
                    },
                }),
                setCellHeaderProps: () => ({className: "text_right",
                    style : {
                        minWidth: i18n.language === "jp" ? "30px" : "",
                        width : i18n.language === "jp" ? "max-content" : "max-content"
                    }
                }),
                display: hideColumnArr.includes("引当数") ? false : true
                 
            },
        },
        {
            name: t("bulk_product_index.free_inventory_quantity_column"),
            options: {
                filter: true,
                sort: false,
                setCellProps: () => ({
                    style: {
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        textAlign:"right",
                        // minWidth: i18n.language === "jp" ? "50px" : "auto",
                        maxWidth : i18n.language === "jp" ? "90px" : "50px"
                    },
                }),
                setCellHeaderProps: () => ({className: "text_right",
                    style : {
                        maxWidth : i18n.language === "jp" ? "90px" : "50px"
                    }
                }),
                display: hideColumnArr.includes("EC表示在庫数") ? false : true, 
            },
        },
        {
            name: t("bulk_product_index.public_flag"),
            options: {
                filter: true,
                sort: false,
                setCellProps: () => ({
                    style: {
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        // maxWidth: 150,
                        minWidth: i18n.language === "jp" ? "70px" : "auto",
                        width : i18n.language === "jp" ? "70px" : "30px"
                        
                    },
                }),
                setCellHeaderProps: () => ({
                    style : {
                        minWidth: i18n.language === "jp" ? "70px" : "auto",
                        width : i18n.language === "jp" ? "70px" : "40px"
                    }
                }),
                display: hideColumnArr.includes("公開フラグ") ? false : true,
            },
        },
        {
            name: t("bulk_product_index.action"),
            options: {
                filter: true,
                sort: false,
                viewColumns: false
            },
            setCellProps: () => ({
                style: {
                    width : "20px"
                },
            }),
            setCellHeaderProps: () => ({
                style : {
                    width : "20px"
                }
            }),
        },
    ];

    const inventoryColumn = [
        "productCode",
        "cainzProductCode",
        "productName",
        "productPrice",
        "shippingFee",
        "quantity",
        "orderedQuantity",
        "freeInventoryQuantity",
        "publicFlag"
    ];

    useEffect(()=>{
        const getNewColumn:any = [];
        hideColumnArr.map((item:any)=>{
            if(item=="商品コード"){
                getNewColumn.push("productCode");
            }else if(item=="カインズ商品コード"){
                getNewColumn.push("cainzProductCode");
            }else if(item=="商品名"){
                getNewColumn.push("productName");
            }else if(item=="税込商品価格"){
                getNewColumn.push("productPrice");
            }else if(item=="個別送料"){
                getNewColumn.push("shippingFee");
            }else if(item=="在庫数"){
                getNewColumn.push("quantity");
            }else if(item=="引当数"){
                getNewColumn.push("orderedQuantity");
            }else if(item=="EC表示在庫数"){
                getNewColumn.push("freeInventoryQuantity");
            }else if(item=="公開フラグ"){
                getNewColumn.push("publicFlag");
            }
        });
        const getResultantColumn = (arr: any[], arr1: any[]): any[] => {
            if (!arr1 || arr1.length === 0) {
                return arr;
            }
            return arr.filter(item => !arr1.includes(item));
        };
        const result = getNewColumn.length === 0 ? inventoryColumn : getResultantColumn(inventoryColumn, getNewColumn);
        setSelectedColumn(result);

    },[hideColumnArr]);
        
    useEffect(()=>{
        if(colFilter||direction){
            productData(firstPage, limit);  
        }
       
    },[colFilter, direction]);

    useEffect(()=>{
        setHideColumnArr([]);
    },[t]); 

    useEffect(() => {
        productData(firstPage, limit);
    }, [appliedFilter1, appliedFilter2]);




    const productData = (currentPage: number, limit: number) => {
        setShowDownloadOptions(false);
        const payload = {};
        const isHitDummyURL = false;
        setSkeleton(true);
        setIsQuantitySearch(false);
        setIsSearch(false);
        new ManageInventoryList(payload, isHitDummyURL)
            .inventoryListData(
                currentPage,
                limit,
                storecode ?? 0,
                search.trim(),
                appliedFilter1,
                appliedFilter2,
                quantity,
                colFilter,
                direction
            )
            .then((res) => {
                setInventory(res);
                setLimit(limit);
                setCurrentPage(currentPage);
                setTotalCount(res?.pagination?.totalCount);
                setTotalPages(res?.pagination?.totalPages);
                setSkeleton(false);
                handleInputQuantity(res);
            })
            .catch((err: any) => {
                setSkeleton(false);
                showSnackbar(err?.message, false);

            });
    };

    const handleInputQuantity = (quantities: any) => {
        const quantityJSON : any = {};
        quantities?.inventories?.map((item: any) => {
            quantityJSON[item?.productCode]= item?.quantity;
        });
        setValue(quantityJSON);
    };

    const downloadProductData = (fileType:any,selectedColumn:any[]) => {
        showSnackbar(t("bulk_product_index.download_started"), true);
        const payload = {};
        const isHitDummyURL = false;
        setLoading(true);
        setShowDownloadOptions(false);
        // setSuccess(false);
        new ManageInventoryList(payload, isHitDummyURL)
            .downloadInventoryListData(
                storecode ?? 0,
                search.trim(),
                appliedFilter1,
                appliedFilter2,
                quantity,
                colFilter,
                direction,
                fileType,
                selectedColumn
            )
            .then((res) => {
                if(typeof res == "string"){
                    showSnackbar(res, true);
                    setLoading(false);
                } else {
                    handleOnExport(res?.inventories);
                }
            })
            .catch((err: any) => {
                setLoading(false);
                setSkeleton(false);
                showSnackbar(err?.message, false);
            });    
    };

    const UpdateManageInventory = (productId: number, ProductCode: any) => {
        if (value[ProductCode] || value[ProductCode] == 0 ) {
            handleLoader(true);
            const payload = { productCode: productId, quantity: value[ProductCode] };
            const isHitDummyURL = false;
            new UpdateInventory(payload, isHitDummyURL)
                .inventoryListUpdateData(productId)
                .then((res) => {
                    handleLoader(false);
                    showSnackbar(res, true);
                    productData(firstPage, limit);
                })
                .catch((err: any) => {
                    handleLoader(false);
                    showSnackbar(err?.message, false);
                });
        }
    };

    const handleKeyPress = (e: any) => {
        if (e.keyCode == 13) {
            setIsSearch(true);
            productData(firstPage, limit);
        }
    };

    const handleSearchChange = (e: any) => {
        setIsSearch(true);
        const { value } = e.target;
        setSearch(value);
    };

    const onsearchApicall = () =>{
        if(isSearch){
            productData(firstPage, limit);
        }
    };
    
    const propItem = [
        onsearchApicall,search
    ];
    lazyTypingUtils(propItem);

    const handleQuantityChange = (e: any) => {
        setIsQuantitySearch(true);
        const { value } = e.target;
        setQuantity(value);
    };

    const onQuantitySearchApicall = () =>{
        if(isQuantitySearch){
            productData(firstPage, limit);
        }
    };
    
    const propQuantityItem = [
        onQuantitySearchApicall,quantity
    ];
    lazyTypingUtils(propQuantityItem);

    const handleFlagFilterChange = (e: any) => {
        const { value } = e.target;
        setAppliedFilter1(value);
    };

    const handleQuantityFilterChange = (e: any) => {
        const { value } = e.target;
        setAppliedFilter2(value);
    };

    const handleOnExport = (downloadArray?: any) => {
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const hour = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const formattedDate= `${year}${month}${day}${hour}${minutes}${seconds}`;
        const downloadData: Array<object> = [];
        downloadArray?.map((item: any) => {
            const data:any = {
                商品コード:item?.productCode,
                カインズ商品コード: item?.cainzProductCode,
                商品名: item?.productName,
                税込商品価格:item?.productPrice,
                個別送料:item?.shippingFee,
                在庫数: item?.quantity,
                引当数: item?.orderedQuantity,
                EC表示在庫数: item?.freeInventoryQuantity,
                公開フラグ:item?.publicFlag==1 ? "公開" : "非公開",
            };
            if(hideColumnArr?.length>0){
                hideColumnArr?.map((key:any)=>{
                    delete data[key];
                });
            }
            downloadData.push(data);
        });
        
        const fileName = `在庫一覧_${storecode}_${formattedDate}.xlsx`;              
        const numFmt="text";
        const allignment = true;
        downloadDataToExcel(downloadData,fileName,SHEET_NAME.MANAGE_INVENTORY,numFmt,allignment);
        setLoading(false);
    };

    const disableSaveButton = (id: number, ProductCode: any) => {
        if(!id)
            return true;
        if(value[ProductCode] === "")
            return true;
        if(value[ProductCode] === 0)
            return false;
        if(value[ProductCode] === null)
            return true;
        return false;
    };

    const actionButton = (id: number, ProductCode: any) => {
        return (
            <CommonButton route={window.location.pathname} functionToExecute={() => UpdateManageInventory(id, ProductCode)} className="" btnName={t("product_list.save")} disableCondition={disableSaveButton(id,ProductCode)} />
        );
    };
    
    const min = 0;
    const max = 9999999;

    const quantityInput = (amount: number, cainzProductCode: any, ProductCode: any) => {
        return (
            <Box className={`${ProductCode < 0 ? "text_right" : "text_right"}`}>
                <Box className="qua_input">
                    <TextField
                        sx={{textAlign:"right", "& input[type=number]": {
                            MozAppearance: "textfield",
                        },}}
                        type="number"
                        inputProps={{ min, max }}
                        value={value[ProductCode]}
                        disabled={ cainzProductCode == "" ? true : false }
                        onChange={(e) => {
                            let values: any = e.target.value == "" ? "" : parseInt(e.target.value, 10);
                            if (values > max) values = max;
                            if (values < min) values = min;
                            e.target.value = values.toString();
                            setValue((prev: any) => ({ ...prev, [ProductCode]: values }));
                        }}
                    />
                </Box>
            </Box>
        );
    };

    const productNameLink = (name: any, id: number,isDemoUser:boolean) => {
        return (
            isDemoUser ? name  :(<Link to={`${process.env.REACT_APP_PRODUCT_BASE_URL}/${id}.html`} target="_blank" rel="noopener noreferrer" className="Order_id_link">
                {name}
            </Link>)
        );
    };

    const rightAlignText = (value:any) =>{
        return(
            <Box className={`${value < 0 ? "product_text_right" : "product_text_right"}`}>{new Utility().numberWithCommas(value)}</Box>
        );
    };

    const inventoryColorValue = (amount: number,orderedQuantity: number,value: any) => {
        return (
            <Box className={`${orderedQuantity > amount ? "inventory_list_quantity_red " : "inventory_list_quantity_black"}`}>{new Utility().numberWithCommas(value)}</Box>
        );
    };

    const apiTableData = () => {
        inventory?.inventories?.map((item: any, index: number) => {
            apiData[index] = [];
            apiData[index].push(
                (currentPage - 1) * limit + index + 1,
                item?.productCode,
                item?.cainzProductCode,
                productNameLink(item?.productName, item?.cainzProductCode,isDemoUser),
                rightAlignText(item?.productPrice),
                rightAlignText(item?.shippingFee),
                quantityInput(value[item?.productCode], item?.cainzProductCode, item?.productCode),
                inventoryColorValue(item?.quantity, item?.orderedQuantity, item?.orderedQuantity),
                inventoryColorValue(item?.quantity, item?.orderedQuantity, item?.freeInventoryQuantity),
                item?.publicFlag == INVENTORY_MODULE_CONSTANTS.STATUS_YES
                    ? t("bulk_product_index.public")
                    : t("bulk_product_index.private"),
                actionButton(item?.cainzProductCode, item?.productCode)
            );
        });
    };
    apiTableData();

    const handleInputType = (e: any) => {
        let inputValue = e.target.value.replace(/[^0-9０-９]/g, "");
        inputValue = inputValue.replace(/[０-９]/g, function(m: any) {
            return String.fromCharCode(m.charCodeAt(0) - 0xfee0);
        });
        inputValue = inputValue.slice(0, 7);
        e.target.value = inputValue;
    };

    useEffect(() => {
        const handleClickOutside = (event: { target: any; }) => {
            if (node.current && !node.current.contains(event.target)) {
                setShowDownloadOptions(false);
            } 
        };
        document.addEventListener("mousedown", handleClickOutside);       
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showDownloadOptions]); 


    return (

        <React.Fragment>
            <Box className="inventory_list">
                <Container sx={{ my: 4 }}>
                    <Grid container spacing={2} sx={{ mb: 5 }}>
                        <Grid item xs={12} sm={6} md={3} lg={3.8}>
                            <TextField
                                label={t("bulk_product_index.search_place_holder")}
                                onChange={handleSearchChange}
                                onKeyUp={handleKeyPress}
                                value={search}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <SearchIconButton
                                                setIsSearchChange={setIsSearch}
                                                apiCallFunction={productData}
                                                page={currentPage}
                                                limit={limit}
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                                variant="outlined"
                                fullWidth
                                size="small"
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={2} lg={2.2} >
                            <TextField
                                label={t("bulk_product_index.inventory_filter")}
                                onChange={handleQuantityChange}
                                onKeyUp={handleKeyPress}
                                value={quantity}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <SearchIconButton
                                                setIsSearchChange={setIsQuantitySearch}
                                                apiCallFunction={productData}
                                                page={currentPage}
                                                limit={limit}
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                                onInput={(e) => handleInputType(e)}   
                                variant="outlined"
                                fullWidth
                                size="small"
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={2} lg={2} >
                            <FormControl size="small" fullWidth>
                                <InputLabel id="demo-multiple-name-label">
                                    {t("bulk_product_index.free_inventory_quantity")}
                                </InputLabel>
                                <Select
                                    id="demo-simple-select"
                                    size="small"
                                    value={appliedFilter2}
                                    onChange={(e) => handleQuantityFilterChange(e)}
                                    fullWidth
                                    input={
                                        <OutlinedInput label={t("bulk_product_index.free_inventory_quantity")} />
                                    }>
                                        
                                    <MenuItem value="true">{t("bulk_product_index.over_sold")}</MenuItem>
                                    <MenuItem value="none">{t("bulk_product_index.all")}</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={2} lg={2}>
                            <FormControl size="small" fullWidth>
                                <InputLabel id="demo-multiple-name-label">
                                    {t("bulk_product_index.public_flag")}
                                </InputLabel>
                                <Select
                                    id="demo-simple-select"
                                    size="small"
                                    value={appliedFilter1}
                                    onChange={(e) => handleFlagFilterChange(e)}
                                    fullWidth
                                    input={
                                        <OutlinedInput label={t("bulk_product_index.public_flag")} />
                                    }>
                                        
                                    <MenuItem value="false">{t("bulk_product_index.private")}</MenuItem>
                                    <MenuItem value="true">{t("bulk_product_index.public")}</MenuItem>
                                    <MenuItem value="none">{t("bulk_product_index.all")}</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                       
                        <Grid item xs={12} sm={6} md={3} lg={2} sx={{position: "relative"}} ref={node} >
                            {totalCount <= INVENTORY_LIST.INVENTORY_LIST_DOWNLOAD_LIMIT ? 
                                <DownloadButton loading={loading}  route={window.location.pathname} functionToExecute={() => downloadProductData("xlsx",selectedColumn)} className="product_list_download" btnName= {t("bulk_product_index.batch_download")} disableCondition={loading || inventory?.inventories?.length == 0 || !inventory?.inventories} />
                                : totalCount <= INVENTORY_LIST.INVENTORY_LIST_DOWNLOAD_LIMIT_CSV ? 
                                    <>
                                        <DownloadButton loading={loading}  route={window.location.pathname} functionToExecute={()=>setShowDownloadOptions(!showDownloadOptions)} className="wd_100" btnName= {t("bulk_product_index.batch_download")} disableCondition={loading || inventory?.inventories?.length == 0 || !inventory?.inventories}  endIconRequired={showDownloadOptions ? <ArrowDropUpIcon /> : <ArrowDropDownIcon/>} />
                                        {showDownloadOptions ?
                                            <><Box sx={{position:"relative"}}>
                                                <Button
                                                    variant="contained"
                                                    fullWidth
                                                    sx={{marginTop:"1px",textTransform: "capitalize"}}
                                                    className="product_list_Download_button margin_excel_download_product"
                                                    disabled={skeleton ||  (totalCount <= INVENTORY_LIST.INVENTORY_LIST_DOWNLOAD_LIMIT_EXCEL ? false : true) }
                                                    onClick={()=>downloadProductData("xlsx",selectedColumn)}
                                                >
                                                    <Box component={"span"} sx={{fontSize:16}}> 
                                                        {t("product_list.excel_download")} 
                                                        <Box component={"div"} sx={{fontSize:10}}>
                                                            {t("product_list.excel_download_error")} 
                                                        </Box>
                                                    </Box>
                                                </Button>
                                                <Button
                                                    variant="contained"
                                                    fullWidth
                                                    sx={{ marginTop:"1px", textTransform: "capitalize"}}
                                                    className="product_list_Download_button margin_csv_download_product"
                                                    disabled={skeleton}
                                                    onClick={()=>downloadProductData("csv",selectedColumn)}
                                                >
                                                    <Box component={"span"} sx={{fontSize:16}}>
                                                        {t("product_list.csv_download")}
                                                        <Box component={"div"} sx={{fontSize:10}}>
                                                            {t("product_list.csv_download_error")}
                                                        </Box>
                                                    </Box>                                                                                   
                                                </Button>
                                            </Box>
                                            </>
                                            : null
                                        }                              
                                    </> 
                                    :    
                                    <>
                                        <Button
                                            variant="contained"
                                            fullWidth
                                            endIcon={<ArrowDropDownIcon />}
                                            disabled={true}
                                        >
                                            {t("product_list.batch_download")}                                          
                                        </Button>
                                        <Typography>{t("product_list.download_limit_exceed")}</Typography>
                                    </>
                            }
                        </Grid>
                    </Grid>
                </Container>

                {skeleton ? (
                    <Skeleton
                        varient="rectangular"
                        width={0}
                        height={60}
                        count="10"
                        my={0}
                    />
                ) : (
                    <>
                        <Box sx={{ overflowX: "auto" }}>
                            <Box sx={{ minWidth: "max-content" }}>
                                <MUIDataTable
                                    title={""}
                                    columns={columns}
                                    data={apiData}
                                    options={{
                                        pagination: false,
                                        print: false,
                                        download: false,
                                        filter: false,
                                        search: false,
                                        selectableRowsHideCheckboxes: true,
                                        textLabels: {
                                            body: {
                                                noMatch: t("table_text.no_match").toString(),
                                            },
                                            viewColumns: {
                                                title: t("table_text.show_columns").toString(),
                                                titleAria: "Show/Hide Table Columns",
                                            },
                                            toolbar: {
                                                search: t("table_text.search").toString(),
                                                viewColumns: t("table_text.view_columns").toString(),
                                            },
                                        },
                                        searchPlaceholder: t("table_text.search_placeholder").toString(),
                                        responsive: "standard",
                                        onSearchChange: (searchText: any) => {
                                            setSearch(searchText ? searchText : "");
                                        },
                                        onViewColumnsChange: (changedColumn:string,action:string) => {
                                            const tempHideColArr=[...hideColumnArr];
                                            if(action==="remove"){
                                                changedColumn=="Product Code"?
                                                    tempHideColArr.push("商品コード"):
                                                    changedColumn=="Product Name"?
                                                        tempHideColArr.push("商品名"):
                                                        changedColumn=="Product Price including Tax"?
                                                            tempHideColArr.push("税込商品価格"):
                                                            changedColumn=="Individual Shipping Fee"?
                                                                tempHideColArr.push("個別送料"):
                                                                changedColumn=="Quantity in Stock"?
                                                                    tempHideColArr.push("在庫数"):
                                                                    changedColumn=="Ordered Quantity"?
                                                                        tempHideColArr.push("引当数"):
                                                                        changedColumn=="EC Display Stock Quantity"?
                                                                            tempHideColArr.push("EC表示在庫数"):
                                                                            changedColumn=="Public Flag (Sales posting flag)"?
                                                                                tempHideColArr.push("公開フラグ"):
                                                                                tempHideColArr.push(changedColumn);

                                                setHideColumnArr(tempHideColArr);
                                            }
                                            else{
                                                let index=-1;
                                                changedColumn=="Product Code"?
                                                    index = tempHideColArr.indexOf("商品コード"):
                                                    changedColumn=="Product Name"?
                                                        index = tempHideColArr.indexOf("商品名"):
                                                        changedColumn=="Product Price including Tax"?
                                                            index = tempHideColArr.indexOf("税込商品価格"):
                                                            changedColumn=="Individual Shipping Fee"?
                                                                index = tempHideColArr.indexOf("個別送料"):
                                                                changedColumn=="Quantity in Stock"?
                                                                    index = tempHideColArr.indexOf("在庫数"):
                                                                    changedColumn=="Ordered Quantity"?
                                                                        index = tempHideColArr.indexOf("引当数"):
                                                                        changedColumn=="EC Display Stock Quantity"?
                                                                            index = tempHideColArr.indexOf("EC表示在庫数"):
                                                                            changedColumn=="Public Flag (Sales posting flag)"?
                                                                                index = tempHideColArr.indexOf("公開フラグ"):
                                                                                index = tempHideColArr.indexOf(changedColumn);
                                                tempHideColArr.splice(index,1);
                                                setHideColumnArr(tempHideColArr);
                                            }
                                        }

                                    }}
                                />
                            </Box>
                        </Box>
                        <Pagination
                            totalCount={totalCount}
                            currentPage={currentPage}
                            pageChange={productData}
                            totalPage={totalPages}
                            rowsPerPage={limit}
                            rowsPerPageChange={setLimit}
                        />
                    </>
                )}
            </Box>
        </React.Fragment>
    );
};

export default ManageInventory;
